// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
// JS that we expect to change very infrequently:
// - external libraries
// - deprecated Academia.edu utility & parent-class code
// - very basic, static infrastructure (`Aedu` namespace, $image_url)
//
// Does what you're adding belong in application.js, or a page-specific file?
//
// Put any new libraries as close to the top as you can, while remaining below
// any dependencies (e.g. jquery).

//= require jade/runtime

//= require requirejs

//= require jquery
//= require jquery.payment/index
//= require trunk8
//= require underscore

//= require bootstrap

//= require backbone
//= require base/_namespace
//= require_tree ./backbone/deprecated_academia_base

//= require_tree ./jquery_plugins
//= require deprecated_object_hierarchy
//= require deprecated_widget_dsl

//= require fullstory

//= require scribd_api

//= require core_pre_webpack
// MAGIC_DESPROCKET_START
require('sprocket-compat?module!jade/runtime.js')
require('sprocket-compat?this&pre&post!requirejs/require.js')
require('javascripts/jquery/index_FORMERLY_SPROCKETS.wjs.js')
require('javascripts/jquery.payment/index.js')
require('javascripts/former-gems/rails-assets-kevinwuhoo--trunk8-1.3.5/app/assets/javascripts/trunk8.js')
require('javascripts/former-gems/rails-assets-kevinwuhoo--trunk8-1.3.5/app/assets/javascripts/trunk8/trunk8.js')
require('!!sprocket-compat?this&module!underscore/underscore.js')
require('bootstrap/dist/js/bootstrap.js')
require('!!sprocket-compat?this&module!backbone/backbone.js')
require('sprocket-compat?this!javascripts/base/_namespace.coffee')
require('sprocket-compat?this!javascripts/backbone/deprecated_academia_base/model.coffee')
require('sprocket-compat?this!javascripts/backbone/deprecated_academia_base/view.coffee')
require('javascripts/jquery_plugins/jquery.autosize-1.18.9.js')
require('javascripts/jquery_plugins/jquery.cookie.js')
require('javascripts/jquery_plugins/jquery.form.helpers.js')
require('sprocket-compat?this!javascripts/jquery_plugins/jquery.more_link.coffee')
require('!!javascripts/jquery_plugins/jquery.observe-2.0.1.js')
require('javascripts/jquery_plugins/jquery.timeago-0.10.0.js')
require('javascripts/jquery_plugins/misc_extensions.js')
require('javascripts/deprecated_object_hierarchy/index.js')
require('javascripts/deprecated_widget_dsl.js')
require('javascripts/scribd_api/index.js')
require('javascripts/core_pre_webpack/index.js')
// MAGIC_DESPROCKET_END
